import Feeder from "./Feeder";
import { showEpgUpdateProgress } from "../helpers/Utils";
import logger from 'src/utils/logger/logger';

class AndroidFeeder extends Feeder{
    constructor(){
        super();
    }

    async updateOfflineEpg(urls=[], updateProgressMessageType){
        try{
            logger.debug('[AndroidFeeder] updateLocalEpg urls', urls);
            showEpgUpdateProgress(updateProgressMessageType, 1);
            urls = JSON.stringify({ urls });
            window.AndroidDBInterface.updateLocalEpg(urls);
            showEpgUpdateProgress(updateProgressMessageType, 100);
            return new Promise(resolve=>resolve(true));
        }
        catch(e){
            logger.error('[AndroidFeeder] updateOfflineEpg catch e', e);
            return new Promise(resolve=>resolve(false));
        }
    }
}

export default AndroidFeeder;



// WEBPACK FOOTER //
// ./src/AAFPersistenceManager/feeders/AndroidFeeder.js